import { render, staticRenderFns } from "./JobSettingsList.vue?vue&type=template&id=5c2c382a&"
import script from "./JobSettingsList.vue?vue&type=script&lang=js&"
export * from "./JobSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports